import { HTMLChakraProps, Icon } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';

import LockIconOpen from '@/assets/icons/ic-lock-open.svg';
import LockIcon from '@/assets/icons/ic-lock.svg';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { LectureCardSkeleton } from '@/components/ui/shared/lecture/LectureCard/LectureCardSkeleton/LectureCardSkeleton';
import { ThinLectureCard } from '@/components/ui/shared/lecture/ThinLectureCard/ThinLectureCard';
import { querySubsequentLecture } from '@/fetchers/thinLectures';
import { useResources, useResource } from '@/lib/datx-jsonapi-react';
import { queryLectureAccessPermission } from '@/queries/lecture-access-permissions';

export const NextThinLecture: FC<HTMLChakraProps<'div'>> = () => {
  const { id } = useLecturePageQueryParams();
  const { data: nextLecture } = useResources(querySubsequentLecture(id));
  const lectureEvent = nextLecture[0].event;

  const firstNextLecture = nextLecture?.[0];
  const { data: lecturePermission } = useResource(queryLectureAccessPermission(firstNextLecture?.id));

  if (!nextLecture || !lectureEvent || !lecturePermission) {
    return <LectureCardSkeleton />;
  }
  return (
    <NextLink href={`/lecture/${nextLecture[0]?.linkSlug}`} passHref legacyBehavior>
      <ThinLectureCard
        icon={
          <Icon
            as={lecturePermission.restricted ? LockIcon : LockIconOpen}
            h="1.5rem"
            w="1.5rem"
            color={lecturePermission.restricted ? 'gray.500' : 'teal.500'}
          />
        }
        as="a"
        lecture={nextLecture[0]}
        event={lectureEvent}
      />
    </NextLink>
  );
};
